import React from 'react';
import './formIpSetRoutes.css';

function FormIPInterfaces(props) {
  const { iface, handleChangeValues, disableInput } = props;
  const checkIfaces = iface.map((int) => int.includes('_') ? int.split('_').join('.') : int)

  return (
    <div className="route-form-card">
      <div className="route-form-header">
        <svg className="route-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
        </svg>
        <h3 className="route-form-title">Configuração de Rota</h3>
      </div>

      <div className="route-form-fields">
        <div className="route-field">
          <label className="route-label">IP/Sub-Rede de Destino</label>
          <input 
            className="route-input" 
            name="srdest" 
            type="text" 
            placeholder="1.1.1.2" 
            disabled={ disableInput } 
            onBlur={(e) => handleChangeValues(e.target)} 
          />
          <p name="srdest-invalid-data" className='route-error is-hidden'>Caracteres inválidos!</p>
        </div>

        <div className="route-field">
          <label className="route-label">Máscara</label>
          <input 
            className="route-input" 
            name="mask" 
            type="text" 
            placeholder="255.255.255.0" 
            disabled={ disableInput } 
            onBlur={(e) => handleChangeValues(e.target)} 
          />
          <p name="mask-invalid-data" className='route-error is-hidden'>Caracteres inválidos!</p>
        </div>

        <div className="route-field">
          <label className="route-label">Gateway</label>
          <input 
            className="route-input" 
            name="gw" 
            type="text" 
            placeholder="1.1.1.1" 
            disabled={ disableInput } 
            onBlur={(e) => handleChangeValues(e.target)} 
          />
          <p name="gw-invalid-data" className='route-error is-hidden'>Caracteres inválidos!</p>
        </div>

        <div className="route-field">
          <label className="route-label">Interface</label>
          <div className="route-select-wrapper">
            <select 
              className="route-select" 
              name="iface" 
              disabled={ disableInput } 
              onChange={(e) => handleChangeValues(e.target)}
            >
              <option value="">Selecione</option>
              { checkIfaces.map((i) => <option key={ i } value={ i }>{ i }</option>) }
            </select>
          </div>
          <p name="iface-invalid-data" className='route-error is-hidden'>Caracteres inválidos!</p>
        </div>
      </div>
    </div>
  );
}

export default FormIPInterfaces;
